import React, { useEffect, useState } from "react";
import "./Products.scss";
import List from "../../components/List/List";
import { useParams } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import sample from "../../img/banner.mp4";
import axios from "axios";

const Products = () => {
  const catId = parseInt(useParams().id);
  const [selectSubCategory, setSelectSubCategory] = useState([]);
  const [selectFlov, setSelectFlov] = useState([]);
  const [data, setData] = useState([]);
  const [selectedSubCatId, setSelectedSubCatId] = useState('');

  const [maxPrice, setMaxPrice] = useState(200);
  const [sort, setSort] = useState(null);
  const [catData,setCatData]= useState([]);
  const [flovData, setFlovData] = useState([]);
  const url =  process.env.REACT_APP_API_URL


useEffect(() => {
  const getSubCat = async () => {
    try {
      const response = await axios.get(
        `${url}/sub-categories?populate[flavors]=*&filters[categories][id][$eq]=${catId}`
      );
      setCatData(response.data.data.reverse());
    } catch (error) {
      // failed to load subcategories
    }
  };
  getSubCat();
}, []);



//console.log("selectSubCategory", selectSubCategory);

const handleChangeflov = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedSubCatId(selectedId);
  setSelectSubCategory([e.target.value]); // keep as string for filter
  setSelectFlov([]); // reset flavors
};

const selectedSubCat = catData.find((item) => item.id === selectedSubCatId);

const selectedFlavors = (selectedSubCat?.attributes?.flavors?.data || []).sort(
  (a, b) => {
    const titleA = a?.attributes?.title || "";
    const titleB = b?.attributes?.title || "";
    return titleA.localeCompare(titleB);
  }
);

  return (
    <div className="__mw">
      <div className="home">
        <div className="hero_wrappe ">
          <div className="video">
            <video className="videoTag" autoPlay loop muted>
              <source src={sample} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>

      <div className="products __wrap">
        <div className="left">
          <div className="filterItem">
            <h2>Product Categories</h2>
            {catData?.map((item) => (
              <div className="inputItem" key={item.id}>
                <input
                  type="radio" // use radio to allow only one selected at a time
                  name="subCategory"
                  id={`cat-${item.id}`}
                  value={item.id}
                  onChange={handleChangeflov}
                />
                <label htmlFor={`cat-${item.id}`}>
                  {item.attributes.title}
                </label>
              </div>
            ))}

            <br />

            {selectedFlavors.length > 0 && (
              <div className="flavorList">
                <h3>Flavors for {selectedSubCat?.attributes?.title}:</h3>
                <br />
                {selectedFlavors.map((flavor) => (
                  <div key={flavor.id} className="inputItem">
                    <input
                      type="checkbox"
                      id={`flavor-${flavor.id}`}
                      value={flavor.id}
                      onChange={(e) => {
                        const value = e.target.value;
                        const isChecked = e.target.checked;
                        setSelectFlov((prev) =>
                          isChecked
                            ? [...prev, value]
                            : prev.filter((item) => item !== value)
                        );
                      }}
                    />
                    <label htmlFor={`flavor-${flavor.id}`}>
                      {flavor.attributes.title}
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="right">
          <div className="free_banner">
            {/*<img src={require("../../img/free.png")} /> */}
          </div>
          <List
            catId={catId}
            maxPrice={maxPrice}
            sort={sort}
            subCats={selectSubCategory}
            flov={selectFlov}
          />
        </div>
      </div>
    </div>
  );
};

export default Products;
